import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import { App2 } from "./App2.jsx";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
// import { Work } from "./work.jsx";
// import { About } from "./about.jsx";
import { Skills } from "./components/Skills.jsx";
import WorkMain from "./workMain.jsx";
import { WorkSection } from "./work.jsx";
import App3 from "./App3.jsx";
import { Navbar } from "./components/Navbar.tsx";
import Contact from "./contact.jsx";
import MazeGame from "./components/MazeGame.jsx";
import MazeCircular from "./components/MazeCircular.jsx";
import { Dice } from "./components/Dice.jsx";
import Trails from "./components/Trails.jsx";
import DinoGame from "./components/DinoGame.jsx";
import WaterScene from "./Water.jsx";
import { Experience } from "./components/Rick/Experience.jsx";

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <>
        <Navbar />
        <App />
      </>
    ),
  },
  {
    path: "/skills",
    element: (
      <>
        <Navbar />
        <App2 />
      </>
    ),
  },
  // {
  //   path: "/work",
  //   element: (
  //     <>
  //       <Navbar />
  //       <WorkMain />
  //     </>
  //   ),
  // },
  // {
  //   path: "/work-3d",
  //   element: (
  //     <>
  //       <Navbar />
  //       <WorkSection />
  //     </>
  //   ),
  // },
  {
    path: "/game",
    element: (
      <>
        <MazeCircular />
        {/* <MazeGame /> */}
      </>
    ),
  },
  {
    path: "/rick",
    element: (
      <>
        <Experience />
        {/* <MazeGame /> */}
      </>
    ),
  },
  // {
  //   path: "/dice",
  //   element: (
  //     <>
  //       <Dice />
  //       {/* <MazeGame /> */}
  //     </>
  //   ),
  // },
  // {
  //   path: "/trails",
  //   element: (
  //     <>
  //       <Trails />
  //       {/* <MazeGame /> */}
  //     </>
  //   ),
  // },
  // {
  //   path: "/dino",
  //   element: (
  //     <>
  //       <DinoGame />
  //       {/* <MazeGame /> */}
  //     </>
  //   ),
  // },
  // {
  //   path: "/water",
  //   element: (
  //     <>
  //       <WaterScene />
  //       {/* <MazeGame /> */}
  //     </>
  //   ),
  // },
  // {
  //   path: "/contact",
  //   element: (
  //     <>
  //       <Navbar />
  //       <Contact />
  //     </>
  //   ),
  // },
]);

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);






























// import React from "react";
// import ReactDOM from "react-dom/client";
// import { createBrowserRouter, RouterProvider, Route, useLocation } from "react-router-dom";
// import { AnimatePresence, motion } from "framer-motion";
// import App from "./App.jsx";
// import { App2 } from "./App2.jsx";
// import WorkMain from "./workMain.jsx";
// import { WorkSection } from "./work.jsx";
// import { Navbar } from "./components/Navbar.tsx";
// import Contact from "./contact.jsx";

// const PageWrapper = ({ children }) => {
//   const location = useLocation();

//   return (
//     <AnimatePresence mode="wait">
//       <motion.div
//         key={location.pathname}
//         initial={{ opacity: 0.5 }}
//         animate={{ opacity: 1 }}
//         exit={{ opacity: 0 }}
//         transition={{ duration: 0.5 }}
//       >
//         {children}
//       </motion.div>
//     </AnimatePresence>
//   );
// };

// const router = createBrowserRouter([
//   {
//     path: "/",
//     element: (
//       <PageWrapper>
//         <Navbar />
//         <App />
//       </PageWrapper>
//     ),
//   },
//   {
//     path: "/skills",
//     element: (
//       <PageWrapper>
//         <Navbar />
//         <App2 />
//       </PageWrapper>
//     ),
//   },
//   {
//     path: "/work",
//     element: (
//       <PageWrapper>
//         <Navbar />
//         <WorkMain />
//       </PageWrapper>
//     ),
//   },
//   {
//     path: "/work-3d",
//     element: (
//       <PageWrapper>
//         <Navbar />
//         <WorkSection />
//       </PageWrapper>
//     ),
//   },
//   {
//     path: "/contact",
//     element: (
//       <PageWrapper>
//         <Navbar />
//         <Contact />
//       </PageWrapper>
//     ),
//   },
// ]);

// ReactDOM.createRoot(document.getElementById("root")).render(
//   <React.StrictMode>
//     <RouterProvider router={router} />
//   </React.StrictMode>
// );
